import React from 'react';
import {Pressable, StyleSheet, Text, View} from 'react-native';

import {space} from '../../design-system/tokens';

import ChevronRightImg from './assets/ChevronRight.svg';
import {chromeType} from './chromeType';
import {headerChrome} from './headerChrome';

const CHEVRON_SIZE = 16;
// SHORTCUT: height 24 and hitSlop 10 are literals: 24 + 2 × 10 = 44, the iOS minimum touch
// target. No touch-target token exists. Upgrade path: a DIS-1735 control-size token.
const BOX = 24;
const HIT_SLOP = 10;
const LABEL = 'Back to store';

/**
 * Gift-card store only (2026-10-21): returns to the liquor store, as the drawer's "Go back to
 * the store" does. The label is visible: a bare chevron beside "Gift Card Store" reads as a
 * link to the gift-card store. Reuses ChevronRight.svg, turned to point left.
 */
export const BackToStoreButton = ({onPress}: {onPress(): void}) => (
  <Pressable
    testID="site-header-back-to-store"
    onPress={onPress}
    hitSlop={HIT_SLOP}
    style={styles.box}
    accessibilityRole="button"
    accessibilityLabel={LABEL}>
    {/* The turn sits on a View: a web svgr <svg> gets the RN transform array as invalid CSS
        and drops it, so the chevron pointed right. */}
    <View testID="site-header-back-to-store-chevron" style={styles.chevron}>
      <ChevronRightImg
        viewBox={`0 0 ${CHEVRON_SIZE} ${CHEVRON_SIZE}`}
        width={CHEVRON_SIZE}
        height={CHEVRON_SIZE}
        color={headerChrome.onGround}
        aria-hidden={true}
      />
    </View>
    <Text style={styles.label}>{LABEL}</Text>
  </Pressable>
);

const styles = StyleSheet.create({
  box: {height: BOX, flexDirection: 'row', alignItems: 'center', gap: space.s4, flexShrink: 0},
  chevron: {flexShrink: 0, transform: [{rotate: '180deg'}]},
  label: {...chromeType.label12Medium, color: headerChrome.onGround},
});
